<template>
  <v-snackbar
    v-model="snackbar"
    :color="color"
    :timeout="timeout"
    multi-line
    top
    class="text-center"
  >
    {{ message }}
    <v-btn icon left @click="snackbar = false">
      <v-icon>mdi-close</v-icon>
    </v-btn>
  </v-snackbar>
</template>

<script>
export default {
  name: 'SnackBar',
  data() {
    return {
      snackbar: false,
      message: '',
      color: 'primary',
      defaultTimeout: 9000,
      timeout: 9000,
      timerId: null,
    }
  },
  mounted() {
    this.$root.$on('show-snackbar', (message, color, timeout) => {
      if (this.timerId) {
        clearTimeout(this.timerId)
      }
      if (!timeout) {
        timeout = this.timeout
      }
      if (color) {
        this.color = color
      }
      if (message.response) {
        message = message.response.data
      }
      let mes = message
      if (message.message) {
        mes = message.message
      }
      if (message.detail) {
        mes += ' ' + message.detail
      }
      this.message = mes
      this.snackbar = true
      this.timeout = timeout
      if (this.timerId) {
        clearTimeout(this.timerId)
      }
      this.timerId = setTimeout(() => {
        this.message = ''
        this.snackbar = false
        this.color = 'primary'
        this.timeout = this.defaultTimeout
      }, timeout)
    })
  },
  beforeDestroy() {
    this.$root.$off('show-snackbar')
    if (this.timerId) {
      clearTimeout(this.timerId)
    }
  },
}
</script>
